import { useIntl } from 'react-intl';
import { Selector } from 'sonata-react-components';

import type { SelectorOptionPropsInterface } from 'sonata-react-components';

type Props = {
  advertisers?: { _id: string; name: string }[];
  id: string;
  onFilterStatus?: (state: { id: string; value: any }[]) => { id: string; value: any }[];
  value?: string[];
};

export default function Advertiser({ advertisers, id, onFilterStatus, value }: Props) {
  const { formatMessage } = useIntl();

  const options: SelectorOptionPropsInterface[] =
    advertisers?.map(({ _id, name }) => ({
      id: _id,
      label: name
    })) || [];

  const selectedValue: SelectorOptionPropsInterface[] =
    advertisers
      ?.filter(({ _id }) => value?.includes(_id))
      ?.map(({ _id, name }) => ({
        id: _id,
        label: name
      })) || [];

  const handleChange = (changedSelectedOptions: SelectorOptionPropsInterface[]) => {
    onFilterStatus?.([
      {
        id: 'advertiserIds',
        value: changedSelectedOptions.length
          ? changedSelectedOptions.map(({ id: selectedOptionId }) => selectedOptionId.toString())
          : undefined
      }
    ]);
  };

  return (
    <Selector<SelectorOptionPropsInterface[]>
      id={`${id}_selector`}
      label={formatMessage({
        defaultMessage: 'Advertiser',
        id: 'campaignPlans.filters.status.advertiser'
      })}
      onChange={handleChange}
      options={options}
      showDeselectOption
      showSelectedItems={false}
      type="multiple"
      value={selectedValue}
    />
  );
}
